export default "__VITE_ASSET__CuMCs3vI__"